import { type FC } from 'react'
import { Layout } from '@egw/layouts'
import { Headers } from '@egw/components'
import { useTranslation } from '@egw/i18n'
import { Statements } from '@egw/features-documents'

export const StatementsPage: FC = () => {
  const { t } = useTranslation()
  return (
    <Layout>
      <Headers title={t('pages.documents.title')} />
      <Statements />
    </Layout>
  )
}
